import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteEmployeeRedux } from "../../../actions/index";
import { connect } from "react-redux";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// expense.month looks like "April,2026" — parse into a real Date so
// months sort chronologically (newest first) instead of alphabetically.
function parseMonthId(id) {
  const [monthName, year] = String(id).split(",");
  const monthIndex = MONTH_NAMES.indexOf((monthName || "").trim());
  return new Date(parseInt(year, 10) || 0, monthIndex >= 0 ? monthIndex : 0, 1);
}

export class Datatable extends Component {
  render() {
    const { myData, history, name, startToggleModal } = this.props;

    const rows = [...(myData || [])].sort(
      (a, b) => parseMonthId(b.month) - parseMonthId(a.month)
    );

    return (
      <Fragment>
        <div className="em-table-wrap">
          <table className="table em-table">
            <thead>
              <tr>
                <th scope="col">Month</th>
                <th scope="col">Salary</th>
                <th scope="col">Total</th>
                <th scope="col" className="em-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={4} className="em-empty">
                    <EmptyState>No records yet.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => {
                  const monthObj = (myData || []).find(
                    (month1) =>
                      month1.id === `${expense.month}-SALARY-${name}`
                  );
                  return (
                    <tr key={i}>
                      <td>{expense.month}</td>
                      <td>
                        <span className="em-amount-pill">{expense.salary ? expense.salary : 0}Tk</span>
                      </td>
                      <td>
                        <span className="em-amount-pill">{expense.amount}Tk</span>
                      </td>
                      <td className="em-col-action">
                        {monthObj && !monthObj.paid && (
                          <button
                            type="button"
                            className="em-icon-btn em-icon-btn--edit"
                            onClick={() => startToggleModal(expense)}
                          >
                            <i className="fa fa-pencil"></i>
                          </button>
                        )}
                        <button
                          type="button"
                          className="em-icon-btn em-icon-btn--view"
                          onClick={() => {
                            history.push(`/expense/employees/${expense.month}-${name}`);
                          }}
                        >
                          <i className="fa fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default connect(null, { deleteEmployeeRedux })(Datatable);
